import React from "react";
import { Link } from "react-router-dom";
import { Phone, MapPin, Clock } from "lucide-react";
import ChatWidget from "../components/ChatWidget";

export default function ChatPage() {
  return (
    <div
      data-testid="chat-page"
      style={{
        minHeight: "100vh",
        background:
          "linear-gradient(180deg, rgba(12,39,71,0.85), rgba(12,39,71,0.6)), url('https://images.pexels.com/photos/7422520/pexels-photo-7422520.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940') center/cover no-repeat",
        color: "#fff",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <nav
        style={{
          padding: "14px 24px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          borderBottom: "2px solid #C49A45",
          background: "rgba(12,39,71,0.65)",
          backdropFilter: "blur(6px)",
        }}
      >
        <Link to="/" data-testid="chat-back-home" style={{ color: "#fff", textDecoration: "none", display: "flex", alignItems: "center", gap: 12 }}>
          <div
            style={{
              width: 36,
              height: 36,
              borderRadius: 999,
              background: "linear-gradient(160deg, #C49A45, #e2b95b)",
              color: "#0C2747",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontFamily: "'Playfair Display', serif",
              fontWeight: 700,
              fontSize: 18,
            }}
          >
            S
          </div>
          <div>
            <div className="font-display" style={{ fontSize: 18, fontWeight: 700, lineHeight: 1 }}>
              Srinidhi
            </div>
            <div style={{ fontSize: 11, opacity: 0.75, marginTop: 2 }}>Dental & Implant Clinic</div>
          </div>
        </Link>
        <a
          data-testid="chat-page-call"
          href="tel:+919321636840"
          style={{ color: "#fff", background: "rgba(255,255,255,0.12)", border: "1px solid rgba(255,255,255,0.25)", padding: "8px 14px", borderRadius: 999, fontSize: 13, textDecoration: "none", display: "inline-flex", alignItems: "center", gap: 6 }}
        >
          <Phone size={14} /> +91 93216 36840
        </a>
      </nav>

      <main
        style={{
          flex: 1,
          display: "grid",
          gridTemplateColumns: "minmax(0, 1fr) minmax(320px, 460px)",
          gap: 40,
          padding: "48px 32px",
          maxWidth: 1240,
          margin: "0 auto",
          width: "100%",
          alignItems: "start",
        }}
      >
        <section>
          <div style={{ color: "#e2b95b", letterSpacing: "0.14em", fontSize: 12, textTransform: "uppercase", marginBottom: 8 }}>
            Standalone chat · Assistant
          </div>
          <h1 className="font-display" style={{ fontSize: 42, lineHeight: 1.08, margin: 0, fontWeight: 700 }}>
            Talk to the clinic's assistant.
          </h1>
          <p style={{ marginTop: 14, lineHeight: 1.6, color: "#dbeafe", maxWidth: 520 }}>
            Ask about treatments, indicative fees, timings, directions, or book a consultation with
            Dr. Srinidhi L. Govind, MDS Prosthodontist. English, हिन्दी, मराठी and தமிழ் all welcome.
          </p>

          <div style={{ marginTop: 32, display: "grid", gap: 14 }}>
            <InfoRow icon={<MapPin size={16} />} label="B-54, 5th Floor, Gurudev Apartments, Opp. Chembur Telephone Exchange, Chembur Naka, Mumbai 400 071" />
            <InfoRow icon={<Clock size={16} />} label="Mon–Sat 10:00 AM – 1:30 PM · 5:00 – 8:30 PM · Sundays by prior appointment" />
            <InfoRow icon={<Phone size={16} />} label="+91 93216 36840 (Call / WhatsApp) · info@srinidhidental.com" />
          </div>

          <div
            data-testid="chat-page-disclaimer-card"
            style={{
              marginTop: 32,
              background: "rgba(255,255,255,0.06)",
              border: "1px solid rgba(226,185,91,0.35)",
              padding: 16,
              borderRadius: 14,
              maxWidth: 560,
              color: "#f8fafc",
              fontSize: 13,
              lineHeight: 1.55,
            }}
          >
            This is an automated assistant — not medical advice. All fees quoted are indicative;
            final pricing is confirmed only in person at the clinic, after Dr. Srinidhi examines you.
          </div>
        </section>

        <section
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              width: "100%",
              height: 640,
              maxWidth: 420,
              position: "relative",
              borderRadius: 18,
              overflow: "hidden",
              boxShadow: "0 24px 60px rgba(12, 39, 71, 0.30)",
              border: "1px solid rgba(226,185,91,0.35)",
              background: "#fff",
            }}
          >
            <ChatWidget embedded />
          </div>
        </section>
      </main>
    </div>
  );
}

function InfoRow({ icon, label }) {
  return (
    <div style={{ display: "flex", gap: 10, alignItems: "flex-start", color: "#e2e8f0", fontSize: 13, lineHeight: 1.5 }}>
      <span style={{ marginTop: 2, color: "#e2b95b" }}>{icon}</span>
      <span>{label}</span>
    </div>
  );
}
